<template>
  <div id="app">
    <success></success>
    <processing v-if="processing"></processing>
    <main_header></main_header>
    <nav id="nav-tool">
      <buttonCart></buttonCart>
      <router-link v-if="$route.path != '/'" to="/" class="btn" id="btn-start">
        <i class="fas fa-flag"></i><div class="d-none d-sm-inline">Start</div>
      </router-link>
    </nav>

    <cart></cart>
    <div class="main-content">
      <div class="container">
        <div class="row">
          <transition name="fade">
            <div class="col-12">
              <div>
              <!-- <div class="min-vh-100 text-center m-0 d-flex flex-column justify-content-center"> -->
                <router-view />
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <footerComponent></footerComponent>
  </div>
</template>

<script>
import main_header from './Views/Header/Header';
import footerComponent from './Views/Footer/Footer';
import cart from './Views/Cart/Cart';
import buttonCart from './Views/Cart/ToggleCart';
import processing from './Views/Processing';
import success from './Views/Success';

export default {

  data() {
    return {
      showCart: false,
      processing: false

    }
  },
  components: {
    buttonCart,
    cart,
    processing,
    success,
    main_header,
    footerComponent
  },
  created() {
    this.$root.$on('update-processing', (state) => { this.$data.processing = state; });

  }
}
</script>
<style lang="scss">

  @import url('https://fonts.googleapis.com/css?family=Montserrat:300,500&display=swap');
  @import url('https://use.fontawesome.com/releases/v5.0.7/css/all.css');
  @import '~bootstrap/dist/css/bootstrap.css';
  @import '~bootstrap-vue/dist/bootstrap-vue.css';


  // Body
  $body-bg: #f5f8fa;

  // Borders
  $laravel-border-color: darken($body-bg, 10%);
  $list-group-border: $laravel-border-color;
  $navbar-default-border: $laravel-border-color;
  $panel-default-border: $laravel-border-color;
  $panel-inner-border: $laravel-border-color;

  // Brands
  $brand-primary: #D1AD5A;
  $brand-info:    #8eb4cb;
  $brand-success: #2ab27b;
  $brand-warning: #cbb956;
  $brand-danger:  #bf5329;

  // Typography
  $icon-font-path: "~bootstrap-sass/assets/fonts/bootstrap/";
  $font-family-sans-serif: "Montserrat-light", sans-serif;
  $font-size-base: 14px;
  $line-height-base: 1.6;
  $text-color: #636b6f;

  $font-light:    300;
  $font-medium:   500;
  $font-semibold: 600;

  // Navbar
  $navbar-default-bg: #fff;

  // Buttons
  $btn-default-color: $text-color;

  // Inputs
  $input-border: lighten($text-color, 40%);
  $input-border-focus: lighten($brand-primary, 25%);
  $input-color-placeholder: lighten($text-color, 30%);

  // Panels
  $panel-default-heading-bg: #fff;

  // Standard Colors
  $black:     #000;
  $white:     #fff;
  $gray:      #707070;
  $lightgray: #F8F7F7;

  // Straalstudio Colors
  html, body {
    font-family: 'Montserrat', sans-serif !important;
    background: #d1ad5a;
  }
  body {
    color: white;
    background-color: #d1ad5a !important;
  }

  #app {

    &.limit {
      max-width: 500px;
    }

    .navbar-dark {
      color: white;
    }

    .main-content {
      > div {
        min-height: 350px;
      }
      padding: 60px 0 80px;
      @media (min-width: 768px) {
        padding: 60px 0 100px;
      }
      @media (min-width: 992px) {
        padding: 60px 0 120px;
      }
    }

  }

  h2 {
    font-size: 2rem;
    color: #ffffff;
  }

  #nav-tool {
    position: relative;
    margin-top: 30px;
    padding: 0px 25px;
  }

  .btn__show_cart{
    position: absolute;
  }

  .btn-primary {
    background-color: #000000 !important;
    text-transform: uppercase !important;
    border-color: #000000 !important;
    font-weight: bold !important;
    border-radius: 0 !important;
    border: none !important;
    text-decoration: none !important;
    &:hover {
      background-color: #ffffff !important;
      color: #000000 !important;
    }
  }

  .btn-outline-primary {
    color: #211875 !important;
    text-transform: uppercase !important;
    border-color: #211875 !important;
    background: white !important;
    font-weight: bold !important;
    padding: 9px 14px!important;
    margin: 5px;
    font-size: .8rem !important;
    margin-bottom: 20px;
    @media (min-width: 600px){
      font-size: 1rem !important;
      margin-bottom: 0;
    }
    @media (min-width: 767px){
      padding: 18px 44px!important;
      margin: 0 10px;
    }
  }

  .btn-danger {
    background-color: #d2ae53;
    border-color: #d2ae53;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  #btn-start {
    border: 1px solid $white;
    border-radius: 0;
    background: transparent;
    padding: 10px 15px;
    display: inline-block;
    transition: all .25s ease;
    color: white;
    text-transform: uppercase;
    @media (min-width: 768px){
        padding: 23px 30px 22px;
        display: inline;
    }
    @media (min-width: 992px){
        &:hover, &:focus, &:active {
          outline: 0;
          color: black;
          background: white;
          i {
              color: black;
              transform: rotate(360deg);
          }
        }
    }
  }

  .fa-flag {
      color: white;
      font-size: 1.1rem;
      transition: all .25s ease;
      @media (min-width: 576px){
          margin-right: 12px;
      }
  }

</style>
